var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "button is-flex is-centered",
      class: _vm.compositeClass,
      attrs: { type: _vm.type, disabled: _vm.disabled },
      on: { click: _vm.onClick }
    },
    [
      _vm._t("default"),
      _vm.text ? _c("span", [_vm._v(_vm._s(_vm.text))]) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }